export default "__VITE_ASSET__DiuscNhG__"